/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Popup_Currentpage_Editonpricedrop3Inputs */

const he_extension_popup_currentpage_editonpricedrop3 = /** @type {(inputs: Extension_Popup_Currentpage_Editonpricedrop3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ערוך ב-pricedrop`)
};

const en_extension_popup_currentpage_editonpricedrop3 = /** @type {(inputs: Extension_Popup_Currentpage_Editonpricedrop3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit on pricedrop`)
};

/**
* | output |
* | --- |
* | "Edit on pricedrop" |
*
* @param {Extension_Popup_Currentpage_Editonpricedrop3Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_popup_currentpage_editonpricedrop3 = /** @type {((inputs?: Extension_Popup_Currentpage_Editonpricedrop3Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Popup_Currentpage_Editonpricedrop3Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_popup_currentpage_editonpricedrop3(inputs)
	return en_extension_popup_currentpage_editonpricedrop3(inputs)
});
export { extension_popup_currentpage_editonpricedrop3 as "extension_popup_currentPage_editOnPricedrop" }